import cn from "classnames";

import { Typography } from "shared/ui/components/Typography";

import { ToggleButtonProps } from "./ToggleButton.types";

import styles from "./ToggleButton.module.scss";

const ToggleButton = ({
  buttonClassName,
  indicatorClassName,
  itemClassName,
  isActive,
  onClickToggle,
  firstName,
  secondName,
  ...restProps
}: ToggleButtonProps) => {
  return (
    <button
      {...restProps}
      className={cn(styles.toggleButton, buttonClassName, {
        [styles.toggleActive]: isActive,
      })}
      onClick={onClickToggle}
    >
      <span
        className={cn(styles.toggleButtonIndicator, indicatorClassName)}
      ></span>
      <Typography
        variant="bodyM"
        className={cn(styles.toggleButtonItem, itemClassName)}
      >
        {firstName}
      </Typography>
      <Typography
        variant="bodyM"
        className={cn(styles.toggleButtonItem, itemClassName)}
      >
        {secondName}
      </Typography>
    </button>
  );
};

export default ToggleButton;
